module.exports = __webpack_public_path__ + "static/media/arts_2.93f60799.jpg";